<template>
  <div class="product-list">
    <template v-for="(product, index) in products">
      <div :key="index" class="product" v-if="checkHideProduct(product)">
        <div class="flex">
          <img :src="product.image" class="mobile-hidden" width="75" height="75">
          <div>
            <div class="tooltip-wrapper">
              <a
                :href="'https://www.amazon.co.jp/gp/offer-listing/' + product.asin"
                target="_blank"
                class="text--underline product-name"
                >
                {{ truncateMiddle(product.productName) }}
              </a>
              <span class="tooltip-text">{{ product.productName }}</span>
            </div>
            <div class="flexbox gap-10">
              <div>
                <b>Amazon価格:</b>
                <span>¥{{ formatNumber(product.amazonPrice) }}</span>
              </div>
              <div>
                <b>在庫数:</b>
                <span>{{ formatNumber(product.quantity) }}</span>
              </div>
            </div>
            <div class="flexbox-between">
              <div class="flexbox mr-r-10">
                <span class="mr-r-10"><b>ASIN：</b>{{ product.asin }}</span>
                <span class="mr-r-10"><b>SKU：</b> {{ product.sku }}</span>
                <span><b>FNSKU：</b>{{ product.fnsku }}</span>
              </div>
              <div v-if="product.skus && Object.keys(product.skus).length > 1" class="dropdown">
                <a class="text--underline" @click.stop>
                その他 {{ Object.keys(product.skus).length - 1 }} 件
                </a>
                <ul class="dropdown-menu">
                  <li
                    v-for="([fnsku, sku], index) in Object.entries(product.skus).filter(([key]) => key !== product.fnsku)"
                    :key="index"
                  >
                    <div><b>SKU：</b>{{ sku }}</div>
                    <div><b>FNSKU：</b>{{ fnsku }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <template v-if="isAdded">
            <span
              class="btn-delete mobile-hidden"
              @click="handleRemoveProduct(product.asin)"
            >
              <i class="fa fa-times-circle"></i>
            </span>
            <button
              class="btn btn-warning mobile"
              @click="handleRemoveProduct(product.asin)"
            >
              削除する
            </button>
          </template>
          <template v-else>
            <button
              class="btn btn-primary"
              :class="{ 'disabled': disabledAdd(product.asin) }"
              :disabled="disabledAdd(product.asin)"
              @click="handleAddProduct(product.asin)"
            >
              {{ disabledAdd(product.asin) ? '追加済み' : '追加する' }}
            </button>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Util from '@/common/utility'

export default {
  props: {
    products: {
      type: Array
    },
    addedAsins: {
      type: Array
    },
    isAdded: {
      type: Boolean
    }
  },
  methods: {
    truncateMiddle (text, maxLength = 80) {
      if (text.length <= maxLength || this.isEntry) return text

      const keepLength = Math.floor((maxLength - 3) / 2)
      const startPart = text.slice(0, keepLength)
      const endPart = text.slice(-keepLength)

      return `${startPart}・・・${endPart}`
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    disabledAdd (asin) {
      return this.addedAsins.includes(asin)
    },
    handleAddProduct (asin) {
      if (this.disabledAdd(asin)) return false

      this.$emit('handleAddProduct', asin)
    },
    handleRemoveProduct (asin) {
      this.$emit('handleRemoveProduct', asin)
    },
    checkHideProduct (product) {
      if (this.isAdded) return true

      return !product.isHide
    }
  }
}
</script>
<style scoped>
.product-list {
  min-height: 390px;
  max-height: 900px;
  overflow-y: auto;
}
.product-list::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.product{
  display: flex;
  border-bottom: 1px solid #ccc;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}
.dropdown .dropdown-menu {
  display: none;
  position: absolute;
  list-style: circle;
  top: unset;
  bottom: 100%;
  left: unset;
  right: 0;
  background: #595959;
  min-width: 200px;
  z-index: 1000;
  padding: 10px 30px;
  margin: unset;
  color: #fff;
  border-radius: unset;
}
.dropdown:hover .dropdown-menu {
  display: block;
}
.btn-delete {
  cursor: pointer;
  font-size: 20px;
  padding: 10px;
}
.btn.disabled {
  background-color: #666;
  border-color: #666;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip-text {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: left;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 110%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  width: 70%;
}

.tooltip-text::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #555 transparent;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.flexbox-between {
  flex-wrap: wrap;
}
@media (max-width: 425px) {
  .product {
    flex-direction: column;
    justify-content: left;
    align-items: start;
  }
  .flexbox-between {
    justify-content: left;
    align-items: start;
  }
  .product-list {
    max-height: 840px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/Products.vue